import React from "react";
import Select from "react-select";

const REPORT_MENU_Z_INDEX = 5000;

/**
 * React Select configured for report filters.
 *
 * Rendering the menu into the document body keeps it above report tables and
 * using fixed positioning prevents a long menu from increasing page height.
 */
export default function ReportSelect({
  styles,
  menuPortalTarget =
    typeof document !== "undefined" ? document.body : undefined,
  menuPosition = "fixed",
  menuPlacement = "auto",
  menuShouldScrollIntoView = false,
  maxMenuHeight = 320,
  ...props
}) {
  const reportStyles = {
    ...styles,
    menuPortal: (base, state) => ({
      ...base,
      ...(styles?.menuPortal ? styles.menuPortal(base, state) : {}),
      zIndex: REPORT_MENU_Z_INDEX,
    }),
  };

  return (
    <Select
      {...props}
      styles={reportStyles}
      menuPortalTarget={menuPortalTarget}
      menuPosition={menuPosition}
      menuPlacement={menuPlacement}
      menuShouldScrollIntoView={menuShouldScrollIntoView}
      maxMenuHeight={maxMenuHeight}
    />
  );
}
